import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { Link } from 'site-modules/shared/components/link/link';
import { ColorList } from 'site-modules/shared/components/color-list/color-list';
import { TooltipItem } from 'site-modules/shared/components/tooltip-item/tooltip-item';
import { FeatureSpecsEntities } from 'client/data/models/vehicle-v2';

import './highlights.scss';

export function Highlights({
  highlightsList = undefined,
  featuresSpecsUrl = undefined,
  creativeId = undefined,
  onRendered = noop,
}) {
  useEffect(() => {
    onRendered();
  }, [onRendered]);

  if (!highlightsList?.length) {
    return null;
  }

  return (
    <div className="my-2" data-tracking-parent={creativeId}>
      <h2 className="size-20 fw-bold">Highlights</h2>
      <dl className="higlights-list mb-1">
        {highlightsList.map(({ name, value, tooltipText }, id) => {
          if (!name || !value) {
            return null;
          }

          const { colors, isExterior } = value;

          return (
            <div key={name} className="highlights-item d-flex align-items-center justify-content-between py-0_75">
              <dt className="text-cool-gray-30 fw-normal">
                <span>{name}</span>
                {tooltipText && (
                  <TooltipItem
                    id={`tooltip-highlights-${id}`}
                    item={{ text: tooltipText, placement: 'bottom' }}
                    className="text-gray-darker d-inline-flex align-self-center top-0"
                    iconClassName="px-0_25"
                    screenReaderTooltipLabel={name}
                  />
                )}
              </dt>
              <dd className="mb-0 fw-bold text-cool-gray-30 text-end">
                {colors ? (
                  <ColorList
                    className="text-end m-0"
                    colors={colors.filter(({ rgb }) => rgb)}
                    keyPrefix={`${isExterior ? 'exterior' : 'interior'}-${id}-`}
                  />
                ) : (
                  value
                )}
              </dd>
            </div>
          );
        })}
      </dl>

      {featuresSpecsUrl && (
        <Link className="text-cool-gray-30 text-underline" to={featuresSpecsUrl} data-tracking-id="view_features_specs">
          <span>All features and specs</span>
          <span className="ms-0_25 text-cool-gray-30 small icon-arrow-right3" aria-hidden />
        </Link>
      )}
    </div>
  );
}

Highlights.propTypes = {
  highlightsList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      displayName: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.shape({
          colors: PropTypes.arrayOf(FeatureSpecsEntities.ColorEntity),
          isExterior: PropTypes.bool,
        }),
      ]),
      tooltipText: PropTypes.string,
    })
  ),
  featuresSpecsUrl: PropTypes.string,
  creativeId: PropTypes.string,
  onRendered: PropTypes.func,
};
